import React, { FC } from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import { BaseControlProps } from '../../../types/controls';

import styles from './styles.module.css';

interface Props extends BaseControlProps {
    className?: string;
    onClick?: () => void;
}

export const ClosePlayerButton: FC<Props> = ({ onClick, className }) => {
    const intl = useIntl();

    return (
        <button
            onClick={onClick}
            className={classnames(styles.root, className)}
            aria-label={intl.formatMessage({
                id: 'features.player.2c9f79d160f6891a33556442dd740edc',
                defaultMessage: 'Close player',
                description: 'Ариа описание для кнопки закрытия плеера',
            })}
        />
    );
};
